import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useFooterContentStore } from '@lib/store';
import { useAccountContext } from '@shared/hooks';
import { PaletteUtils } from '@shared/utils';
import { TermsConditionsModal } from './widgets';
import { Popup } from '@shared/widgets';

interface FooterProps {
  className?: string;
}

export const Footer = (props: FooterProps) => {
  const footerContentStore = useFooterContentStore();
  const { account, card } = useAccountContext();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { t } = useTranslation();

  useEffect(() => {
    footerContentStore.getFooterContent();
  }, []);

  return (
    <>
      <div
        className={clsx(
          'text-[13px] font-normal -tracking-[0.2px] leading-[1.47] mx-auto py-[32px] px-[16px] text-center max-w-[450px] ',
          props.className,
        )}
      >
        <div className='insignia-cards-ui-footer__menu'>
          <span
            className={clsx(
              ' cursor-pointer -leading-[0.3px] my-[2px] mx-[16px] uppercase',
              PaletteUtils.isBordierPalette ? 'text-[#4c4c52]' : 'text-[#dadada]',
            )}
            onClick={() => setIsOpen(true)}
          >
            {t('footer.title')}
          </span>
        </div>
        <div className='text-[#8c8c8d]'>{footerContentStore.data?.map((item) => item.description)}</div>
      </div>
      {account && card && (
        <Popup open={isOpen} onClose={() => setIsOpen(false)} timeout={600}>
          <TermsConditionsModal onClose={() => setIsOpen(false)} account={account} card={card} />
        </Popup>
      )}
    </>
  );
};
